import React from "react";
import { Link } from "react-router-dom";
import "../../common/bg.css";
import "./c.css";
import WebsiteName from "../../common/WebsiteName/WebsiteName";
import Navbar from "../../common/Navbar/NavBar";
import Location from "../../common/Location/Location";
import Footer from "../../common/Footer/Footer";
export default function C_info() {
  return (
    <>
      <section className="bgImageCommon">
        <WebsiteName />
        <Navbar />
        <Location title="Web Programming" />
        <section>
          <div className="cBody">
            <div id="cardDIV">
              <h1 className="text-dark" id="laguage_Title">
                Web Programming
              </h1>
              <p className="text-secondary" id="Language_Para">
                Web programming involves creating dynamic websites that are
                interactive and user-friendly. This includes the use of
                databases, server-side scripting, and client-side scripting to
                create applications that can process data, display content, and
                interact with users.
                <br />
                Web programming, also known as web development, is the creation
                of dynamic web applications. Examples of web applications are
                social networking sites like Facebook or e-commerce sites like
                Amazon. The good news is that learning web development is not
                that hard!
                <br />
                For front-end web development languages, you may want to start
                with HTML, CSS, JavaScript, or PHP. Regarding back-end
                programming languages for web development, consider Java,
                Python, or Ruby. The skills these languages offer overlap enough
                that developers can use them together.
                <br />
              </p>
              <Link
                name=""
                id=""
                class="btn btn-danger"
                to="/Courses"
                role="button">
                {"<< "}back
              </Link>
            </div>
          </div>
        </section>
        <Footer />
      </section>
    </>
  );
}
